import React, { useCallback, memo } from 'react'

import {
  Button,
  classnames,
  ThreeDOnly,
  ThreeDPrintOnly,
  Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { useSearchPageStore } from 'Pods/SearchPage/Store'
import { setAssetType } from 'Pods/SearchPage/Store/actions/assetType'
import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'

const threeDIcon = <Icon svgComponent={ThreeDOnly} size="small" notSpaced />
const threeDPrintIcon = <Icon svgComponent={ThreeDPrintOnly} size="small" notSpaced />

function AssetTypeToggle() {
  const assetType = useSearchPageStore(state => state.assetType)

  const handleAllClick = useCallback(() => {
    setAssetType(ASSET_TYPE.ALL)
  }, [])

  const handleThreeDOnlyClick = useCallback(() => {
    setAssetType(ASSET_TYPE.THREE_D_ONLY)
  }, [])

  const handleThreeDPrintOnlyClick = useCallback(() => {
    setAssetType(ASSET_TYPE.THREE_D_PRINT_ONLY)
  }, [])

  const isAllActive = ASSET_TYPE.ALL === assetType
  const isThreeDOnlyActive = ASSET_TYPE.THREE_D_ONLY === assetType
  const isThreeDPrintOnlyActive = ASSET_TYPE.THREE_D_PRINT_ONLY === assetType

  return (
    <div className="asset-type-toggle">
      <Button
        onClick={handleAllClick}
        isActive={isAllActive}
        type={isAllActive ? 'primary' : 'secondary'}
        customClass={classnames(
          'asset-type-toggle__button',
          isAllActive && 'asset-type-toggle__button--is-active',
        )}
        aria-label="All"
      >
        <span className="asset-type-toggle__all-label">All</span>
      </Button>
      <Button
        onClick={handleThreeDOnlyClick}
        variant="with-icon"
        icon={threeDIcon}
        isActive={isThreeDOnlyActive}
        type={isThreeDOnlyActive ? 'primary' : 'secondary'}
        customClass={classnames(
          'asset-type-toggle__button',
          isThreeDOnlyActive && 'asset-type-toggle__button--is-active',
        )}
        aria-label="3D Only"
      >
        <span className="asset-type-toggle__label desktop-only">3D Only</span>
        <span className="asset-type-toggle__label mobile-only">3D</span>
      </Button>
      <Button
        onClick={handleThreeDPrintOnlyClick}
        variant="with-icon"
        icon={threeDPrintIcon}
        isActive={isThreeDPrintOnlyActive}
        type={isThreeDPrintOnlyActive ? 'primary' : 'secondary'}
        customClass={classnames(
          'asset-type-toggle__button',
          isThreeDPrintOnlyActive && 'asset-type-toggle__button--is-active',
        )}
        aria-label="3D Print Only"
      >
        <span className="asset-type-toggle__label desktop-only">3D Print Only</span>
        <span className="asset-type-toggle__label mobile-only">3D Print</span>
      </Button>
    </div>
  )
}

export default memo(AssetTypeToggle)
